import {useReducer} from "react"

const initialState = {
    anyLoading: false,
    data: {
        parametros: {},
    },
    error: {
        parametros: {
            isError: false,
            errorMessage: "",
        },
    },
    loading: {
        parametros: false,
    },
}

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING": {
            const newLoading = {...state.loading, [action.key]: action.payload,}
            const anyLoading = Object.values(newLoading).some(Boolean)
            return {...state, loading: newLoading, anyLoading,}
        }
        case "SET_DATA":
            return {
                ...state,
                data: {...state.data, [action.key]: action.payload},
                error: {...state.error, [action.key]: {}},
            }
        case "SET_ERROR":
            return {...state, error: {[action.key]: action.payload}}
        default:
            return state
    }
}

export const useParameterMotor = (emissaoService, rendaFixaCaracteristicaID) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const loadParametros = async () => {
        if (!rendaFixaCaracteristicaID || rendaFixaCaracteristicaID === "") {
            dispatch({
                type: "SET_ERROR",
                key: "parametros",
                payload: {
                    isError: true,
                    message: "empty rendaFixaCaracteristicaID value receive",
                },
            })
            return
        }
        dispatch({type: "SET_LOADING", key: "parametros", payload: true})

        try {
            const response = await emissaoService.getParametros(rendaFixaCaracteristicaID)
            const {body: {Parametros}} = response

            dispatch({
                type: "SET_DATA",
                key: "parametros",
                payload: {Parametros},
            })
            return Parametros[0]
        } catch (e) {
            dispatch({
                type: "SET_ERROR",
                key: "parametros",
                payload: {isError: true, message: e},
            })
        } finally {
            dispatch({
                type: "SET_LOADING",
                key: "parametros",
                payload: false,
            })
        }
    }

    return {
        state,
        actions: {
            loadParametros,
        },
    }
}
